import type { ComputerViewModelExtended } from './computer-view-model-extended';

export function computerIsInNetworkWithMedicalData(c: {
  computersInSameNetwork: ComputerViewModelExtended[];
}): boolean {
  const items = c.computersInSameNetwork.filter(function (item) {
    return item.hasMedicalData;
  });
  return items.length > 0;
}
